import React from 'react';

interface ImageHeaderLargeProps {
  imageUrl?: string;
  headerContent: React.ReactNode;
}

export const ImageHeaderLarge: React.FC<ImageHeaderLargeProps> = ({
  imageUrl = 'https://images.squarespace-cdn.com/content/v1/67bee5a0a1150b7d4babf028/f0210efc-9b07-42a1-a03f-e4346ed0948f/238761-v2-672pxh%402x.jpg?format=2500w',
  headerContent,
}) => {
  return (
    <div
      className="image-header-large"
      style={{
        height: '500px',
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: 'center bottom',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <div className="image-header-overlay" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1,
      }} />
      <div className="image-header-content" style={{
        position: 'relative',
        zIndex: 2,
        textAlign: 'center',
        color: 'white',
      }}>
        {headerContent}
      </div>
    </div>
  );
};
